import {ChangeDetectorRef, Component, OnInit, ɵɵtrustConstantResourceUrl} from '@angular/core';
import {NavController, ModalController} from '@ionic/angular';
import {ActivatedRoute} from '@angular/router';
import {Router} from '@angular/router';
import {DataStore} from '@aws-amplify/datastore';
import {Team, User, Bonus} from '../../models';
import {SessionService} from '../services/session.service';
import {DateTime} from "luxon";

//import {CareerController} from '../models/career-controller';

@Component({
    selector: 'app-my-bonuses',
    templateUrl: './my-bonuses.page.html',
    styleUrls: ['./my-bonuses.page.scss'],
})
export class MyBonusesPage implements OnInit {
    project = 'overview';
    period = 'mensile';

    paymentsByMese = [];
    paymentsByTrimestre = [];
    paymentsByAnno = [];
    showCareerPanel = false;
    bonusByPeriod = 500;

    teamBonus = 0.5;
    careerTitle: string = 'Caricamento...';
    overViewStyle = 'temporal';

    currentPanel = 'overview';
    user: any;
    showCompanyBonusPanel = false;
    monthes = {
        '1': 'Gennaio',
        '2': 'Febbraio',
        '3': 'Marzo',
        '4': 'Aprile',
        '5': 'Maggio',
        '6': 'Giugno',
        '7': 'Luglio',
        '8': 'Agosto',
        '9': 'Settembre',
        '10': 'ottobre',
        '11': 'Novembre',
        '12': 'Dicemebre',
    };
    selectedYear: any;
    years = [];
    selectedMonth: any;

    constructor(
        private route: ActivatedRoute,
        public router: Router,
        public sessionService: SessionService,
        private navController: NavController,
        private modalController: ModalController,
        public cd: ChangeDetectorRef
    ) {

    }

    setYearsAndMonths() {
        let now = DateTime.now().get('year');

        while (now > 2019) {
            this.years.push(now);
            now = now - 1;
        }
        this.selectedYear = this.years[0];
        this.selectedMonth = DateTime.now().get('month').toString();
        
        
    }

    async ngOnInit() {
        this.setYearsAndMonths();
        //set years

        //end set years


        this.user = await DataStore.query(User, this.sessionService.user.id);
        this.cd.detach();
        setInterval(() => {
            this.cd.reattach();
            this.cd.detectChanges();
            this.cd.detach();

        }, 1000);
        
        let user = this.user;
        /*     this.careerController = new CareerController(user);
            // 
             this.careerController.teamBonus3$.subscribe(value => this.teamBonus = value);
             this.careerController.careerTitle$.subscribe(value => this.careerTitle = value);

             this.careerSteps.push({
                 role: 'Senior Advisor',
                 percent: 88,
             });
             this.careerSteps.push({
                 role: 'Leader Advisor',
                 percent: 10,
             });
      */
        let paymentsByMesetemp = this.paymentsByTrimestre = this.paymentsByAnno = await DataStore.query(
            Bonus,
            //b => b.userBonusId('eq', this.sessionService.user.id),
        );
        this.paymentsByMese = paymentsByMesetemp.filter(x =>
            x.user?.id == this.sessionService.user.id);
        // this.paymentsByMese = this.paymentsByTrimestre = this.paymentsByAnno = await DataStore.query(Bonus);
        // 

        // this.paymentsByMese.push({ source: 'Contract n.1', url: 'sdfsd', amount: 900, date: '31/12/2021', status: 'pagato' });
        // this.paymentsByMese.push({ source: 'Contract n.2', url: 'dsfsd', amount: 1900, date: '21/12/2021', status: 'nonpagato' });

        // this.paymentsByTrimestre.push({ source: 'Contract n.3', url: '', amount: 900, date: '31/12/2021', status: 'pagato' });
        // this.paymentsByTrimestre.push({ source: 'Contract n.4', url: '', amount: 1900, date: '21/12/2021', status: 'nonpagato' });

        // this.paymentsByAnno.push({ source: 'Contract n.5', url: '', amount: 900, date: '31/12/2021', status: 'pagato' });
        // this.paymentsByAnno.push({ source: 'Contract n.6', url: '', amount: 1900, date: '21/12/2021', status: 'nonpagato' });
    }

    ionViewDidEnter() {
        // make sure the newly styled content scrolls when needed
        document.querySelectorAll('.main-content')[document.querySelectorAll('.main-content').length - 1].shadowRoot.querySelector('.inner-scroll').setAttribute('style', 'height:100%');
    }

    openContract(id) {
        this.router.navigate(['/contract', id]);
    }

    back() {
        this.navController.back();
    }

    setOverViewStyle(category: string) {
        this.overViewStyle = category;

    }

    openPage(s: string) {

    }

    changeYear($event) {
        
        //this.careerController.changeYear($event.detail.value);

    }

    changeMonth($event: Event) {

    }
}
